import { useState, useEffect } from 'react'
import { MotionConfig } from 'framer-motion'

/* O toggle "Pausar animações" do widget de acessibilidade só aplica CSS, que o
   framer-motion ignora (anima estilos inline via rAF). Este provider observa a
   classe a11y-pause-animations e passa reducedMotion="always" ao framer-motion —
   assim o toggle trava de facto as animações do site. Sem a classe, fica em
   "user", respeitando o prefers-reduced-motion do sistema. */
export default function MotionProvider({ children }) {
    const [forcarReduzido, setForcarReduzido] = useState(
        typeof document !== 'undefined' &&
        document.documentElement.classList.contains('a11y-pause-animations')
    )

    useEffect(() => {
        const observer = new MutationObserver(() =>
            setForcarReduzido(document.documentElement.classList.contains('a11y-pause-animations'))
        )
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
        return () => observer.disconnect()
    }, [])

    return (
        <MotionConfig reducedMotion={forcarReduzido ? 'always' : 'user'}>
            {children}
        </MotionConfig>
    )
}
